import React from 'react';
import { Timeline } from 'antd';
import { TimelineItemProps } from 'antd/lib/timeline/TimelineItem';

export type { TimelineItemProps };

const ProTimelineItem: React.FC<TimelineItemProps> = (props) => {
  const { children, ...resProps } = props;

  return <Timeline.Item {...resProps}>{children}</Timeline.Item>;
};

export default ProTimelineItem;
